import Alternatives_AlternativeDashboardPage from "@Alternatives/Alternatives/Pages/AlternativeDashboardPage.vue";
import Alternatives_AlternativesImportPage from "@Alternatives/Alternatives/Pages/AlternativesImportPage.vue";
import Alternatives_EditAlternativePage from "@Alternatives/Alternatives/Pages/EditAlternativePage.vue";

export const routes = [
    {
        path: "/portfolio/alternative/dashboard/:workspaceId/:projectId/:alternativeId",
        component: Alternatives_AlternativeDashboardPage
    },
    {
        path: "/decision/alternative/dashboard/:workspaceId/:projectId/:alternativeId",
        component: Alternatives_AlternativeDashboardPage
    },


    {
        path: "/portfolio/import-alternatives/:workspaceId/:projectId/:alternativesListId",
        component: Alternatives_AlternativesImportPage
    },
    {
        path: "/decision/import-alternatives/:workspaceId/:projectId/:alternativesListId",
        component: Alternatives_AlternativesImportPage
    },

    {
        path: "/alternative/edit/:alternativeId/:formId?",
        component: Alternatives_EditAlternativePage
    },
]
